import { Component, Inject } from "@angular/core";
import { OrganisationService } from "../../organisation/organisation.service";
import { FormControl } from "@angular/forms";
import { Linqset, LinqsetNode, NODE_SUPERTYPE, getInsightsWithoutCreate } from "../../common/linqset-model";
import { FilterService } from "../../model-services/filter.service";
import { Subscription } from "rxjs";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GraphComponent } from "@yfiles/yfiles";
import { getTagGroupsForModel, TagGroup } from "../../common/organisation";

enum NODE_GROUP_TYPE {
    ACTIONS = "Actions",
    SYSTEMS = "Systems",
    ROLES = "Roles",
    INPUTS = "Inputs",
    OUTPUTS = "Outputs"
}

class NodeGroup {
    nodes:LinqsetNode[] = []
    control:FormControl = new FormControl([])

    constructor(public type:NODE_GROUP_TYPE) {
    }

    addNode(node:LinqsetNode, filterService:FilterService) {
        this.nodes.push(node)
        if (filterService.hasNode(node)) {
            this.control.value.push(node)
        }
    }

    sort() {
        this.nodes = this.nodes.sort((a,b) => a.name?.toLowerCase()>b.name?.toLowerCase()?-1:1)
    }
}

@Component({
    selector: 'app-filter',
    templateUrl: './filter.html',
    styleUrls: ['filter.css'],
    standalone: false
})
export class FilterComponent {
    linqset:Linqset
    graphComponent:GraphComponent
    
    tagsControl = new FormControl();

    NODE_GROUP_TYPE = NODE_GROUP_TYPE

    nodeGroups:{} = null
    tagGroups:TagGroup[] = []

    filterSubscription:Subscription

    constructor(
        public dialogRef: MatDialogRef<FilterComponent>,
        private organisationService:OrganisationService, private filterService:FilterService,
        @Inject(MAT_DIALOG_DATA) public info:any) {
            
            this.linqset = info.linqset
            this.graphComponent = info.graphComponent    

            this.setupNodeGroups()
    }

    setupNodeGroups() {
        this.tagsControl.reset(this.filterService.getTagKeys())

        this.nodeGroups = {}
        this.getNodeGroupTypeList().forEach(v => {
            this.nodeGroups[v] = new NodeGroup(v)
        })

        this.tagGroups = getTagGroupsForModel(this.organisationService.organisation, this.linqset.modelKey)

        this.linqset.nodes.forEach(n => {
            this.addNode(n)
        })

        this.getNodeGroupTypeList().forEach(v => {
            this.nodeGroups[v].sort()
        })

    }

    addNodes(nodes:LinqsetNode[]) {
        nodes.forEach(n => this.addNode(n))
    }

    addNode(node:LinqsetNode) {
        const insights = getInsightsWithoutCreate(node, this.linqset)

        if (insights && insights.isInput) {
            this.getNodeGroup(NODE_GROUP_TYPE.INPUTS).addNode(node, this.filterService)
            return
        }
        if (insights && (insights.isOutput || insights.isLastNode)) {
            this.getNodeGroup(NODE_GROUP_TYPE.OUTPUTS).addNode(node, this.filterService)
            return
        }

        if (node.superType === NODE_SUPERTYPE.ACTION) this.getNodeGroup(NODE_GROUP_TYPE.ACTIONS).addNode(node, this.filterService)
        if (node.superType === NODE_SUPERTYPE.ROLE) this.getNodeGroup(NODE_GROUP_TYPE.ROLES).addNode(node, this.filterService)
        if (node.superType === NODE_SUPERTYPE.SYSTEM) this.getNodeGroup(NODE_GROUP_TYPE.SYSTEMS).addNode(node, this.filterService)
    }

    nodeSelectionChange(event) {
        const nodes = Object.values(this.nodeGroups).reduce((a:LinqsetNode[], ng:NodeGroup) => {
            if (ng.control.value) a = a.concat(ng.control.value)
            return a
        }, []) as LinqsetNode[]
        this.filterService.setNodes(nodes)
    }

    tagSelectionChange(event) {
        this.filterService.setTagKeys(event.value)
    }

    getNodeGroupTypeList() {
        return Object.values(NODE_GROUP_TYPE)
    }

    getNodeGroup(type:NODE_GROUP_TYPE) {
        return this.nodeGroups[type]
    }

    isFiltered() {
        return this.filterService.isFiltered
    }

    clearFilter() {
        this.tagsControl.reset()
        Object.values(this.nodeGroups).forEach((ng:NodeGroup) => ng.control.reset())

        this.filterService.clearFilter(this.graphComponent)
    }

    applyFilter() {
        this.filterService.applyFilter(this.linqset, this.graphComponent)
        this.dialogRef.close()
    }

    cancel() {
        this.dialogRef.close()
    }
}
